/**
 * @description 体检报告 examinationReport
 * @author xiehan
 * @date 2018/12/17
 */

import Logic from '../logic-base'

const examinationReportBiz = new Logic()

examinationReportBiz.findCheckReportByPage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.examinationReport.findCheckReportByPage,
    data: data
  })
}

examinationReportBiz.getById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.examinationReport.getById,
    data: data
  })
}

export default examinationReportBiz
